<template>
  <v-card flat class="futuristic-card">
    <v-card-title class="card-header">
      <h4 class="earth-color">VISITOR PASSES</h4>
      <div class="title-decoration"></div>
      <v-spacer></v-spacer>
      <v-text-field
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        v-model="search"
        class="futuristic-input"
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="columns"
      :items="$bookingPasses"
      :search="search"
      :items-per-page-options="[10, 25, { text: 'All', value: -1 }]"
      disable-sort
      :loading="$loadingTrue"
      class="futuristic-table"
    >
      <v-progress-linear v-slot:progress color="#587e27" indeterminate></v-progress-linear>
      <template v-slot:items="{ item }">
        <td>{{ formated_date_time(item.date_created) }}</td>
        <td>{{ item.name }}</td>
        <td>
          <v-btn
            depressed
            color="#0288d1"
            small
            class="futuristic-btn"
            @click="showTicket(item.url)"
          >
            View
          </v-btn>
        </td>
      </template>
      <v-alert v-slot:no-results :value="true" color="#e84118" icon="mdi-alert">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  name: 'Passes',
  data () {
    return {
      search: '',
      columns: [
        {
          text: 'Added On',
          value: 'date_created'
        },
        {
          text: 'Ticket Reference',
          value: 'name'
        },
        {
          text: 'Action',
          value: ''
        }
      ]
    }
  },
  methods: {
    showTicket (url) {
      window.open(url, '_blank')
    }
  },
  created () {
    this.$store.dispatch('get_booking_passes')
  }
}
</script>

<style scoped>
/* Futuristic Card */
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin: 8px 16px 0 0;
  width: 100px;
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.futuristic-table {
  width: 100%;
  border-collapse: collapse;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
}

.futuristic-table >>> th,
.futuristic-table >>> td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.futuristic-table >>> th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  color: #587e27;
  font-weight: 600;
}

.futuristic-table >>> tr:hover {
  background: #f5f7fa;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .futuristic-card {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.25rem;
  }

  .futuristic-btn {
    font-size: 0.9rem;
  }

  .futuristic-table >>> th,
  .futuristic-table >>> td {
    padding: 8px;
  }
}

@media (max-width: 600px) {
  .futuristic-card {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
    flex-direction: column;
    align-items: flex-start;
  }

  .earth-color {
    font-size: 1.1rem;
  }

  .futuristic-btn {
    font-size: 0.85rem;
  }

  .futuristic-table >>> th,
  .futuristic-table >>> td {
    padding: 6px;
    font-size: 0.85rem;
  }

  .futuristic-input {
    width: 100%;
  }
}
</style>
